import React from "react";
import Domain from '../components/Domain';

function DomainsView({ domains }) {
  return (
    <div className="row mt-30-reverse">
      {domains.map(domain => (
        <div className="col-lg-4 col-md-6 col-12 mt-30" key={domain.id} >
          <Domain content={domain} />
        </div>
      ))}
    </div>
  );
}

export default DomainsView;
